<template>
  <VDialog v-model="dialog" width="600px">
    <VCard>
      <VBtn
        absolute
        icon
        right
        style="right: 0"
        class="mt-0 pb-0"
        @click="close"
      >
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardText>
        <VList class="pt-15">
          <VListItem style="min-height: 40px">
            <VListItemContent class="py-0">
              <VListItemTitle>
                {{ $t("productName") }}: <b>{{ item.productName }}</b>
              </VListItemTitle>
            </VListItemContent>
          </VListItem>
          <VListItem style="min-height: 40px">
            <VListItemContent class="py-0">
              <VListItemTitle>
                {{ $t("quantity") }}: <b>{{ item.count }}</b>
              </VListItemTitle>
            </VListItemContent>
          </VListItem>
          <VListItem style="min-height: 40px">
            <VListItemContent class="py-0">
              <VListItemTitle>
                {{ $t("givenProductQuantity") }}: <b>{{ item.remains }}</b>
              </VListItemTitle>
            </VListItemContent>
          </VListItem>
        </VList>
        <ValidationObserver v-slot="{ handleSubmit }" ref="secondQrFormObs">
          <div class="pa-1">
            <CustomInputText
              :rules="{
                required: true,
                max_value: quantity,
              }"
              clearable
              class="user_input no-margin"
              v-model="params.count"
              :label="$t('enterQuantity')"
              type="text"
            ></CustomInputText>
          </div>
          <div class="text-right">
            <VBtn color="success" class="mt-2" @click="handleSubmit(submit)">{{
              $t("giveOut")
            }}</VBtn>
          </div>
        </ValidationObserver>
      </VCardText>
    </VCard>
    <WarningDialog
      yes-text="yes"
      description="wantToDistribute"
      v-model="warningDialog"
      @apply="giveProduct"
      ref="warningDialogRef"
    >
      {{ $t("wantToDistribute", { count: params.count }) }}
    </WarningDialog>
  </VDialog>
</template>

<script>
import WarningDialog from "@/components/ui/prompt/warning-dialog.vue";

const PARAMS = {
  count: null,
  notificationId: null,
  orderItemId: null,
  partitionId: null,
  produceHistoryId: null,
};
export default {
  data() {
    return {
      item: {},
      dialog: false,
      quantity: null,
      warningDialog: false,
      params: { ...PARAMS },
    };
  },
  components: {
    WarningDialog,
  },
  watch: {
    dialog(val) {
      if (!val) {
        if (this.$refs.secondQrFormObs) {
          this.clear();
        }
      }
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    submit() {
      this.warningDialog = true;
    },
    clear() {
      this.params = { ...PARAMS };
      this.quantity = null;
      this.$refs.secondQrFormObs.reset();
    },
    async giveProduct() {
      this.showLoading();
      try {
        await this.$http.post("partition/produce", this.params);
        this.close();
        this.clear();
        this.$emit("productGiven");
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    open(item, child) {
      const remains = +item.count - +item.given;
      this.quantity = remains;
      this.dialog = true;
      this.params.orderItemId = item.id;
      this.params.partitionId = child.id;
      this.item = {
        ...item,
        remains,
      };
    },
  },
};
</script>
